// src/firebase/logEvents.js
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// 1. Login Event
export const logUserLogin = async (email) => {
  try {
    await addDoc(collection(db, "dashboard_logs"), {
      event: "login",
      email,
      timestamp: serverTimestamp(),
      session_id: crypto.randomUUID(),
    });
  } catch (e) {
    console.error("Error logging login:", e);
  }
};

// 2. Export Event
export const logExportEvent = async (email, dashboardName, timeSpent) => {
  try {
    await addDoc(collection(db, "dashboard_logs"), {
      event: "export",
      email,
      dashboard: dashboardName,
      time_spent_seconds: timeSpent,
      exported_at: serverTimestamp(),
    });
  } catch (e) {
    console.error("Error logging export:", e);
  }
};

// 3. Page Visit Event
export const logPageVisit = async (email, dashboardName) => {
  try {
    await addDoc(collection(db, "dashboard_logs"), {
      event: "page_visit",
      email,
      dashboard: dashboardName,
      entered_at: serverTimestamp(),
    });
  } catch (e) {
    console.error("Error logging page visit:", e);
  }
};

// 4. Page Exit Event
export const logPageExit = async (email, dashboardName, timeSpent) => {
  try {
    await addDoc(collection(db, "dashboard_logs"), {
      event: "page_exit",
      email,
      dashboard: dashboardName,
      time_spent_seconds: timeSpent,
      exited_at: serverTimestamp(),
    });
  } catch (e) {
    console.error("Error logging exit:", e);
  }
};
